import script from "./USPTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./USPTile.vue?vue&type=script&setup=true&lang=ts"

import "./USPTile.vue?vue&type=style&index=0&id=3aeadca0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aeadca0"]])

export default __exports__